import React from 'react'
import { ClassHelper } from 'components/lib'
import Style from './userSettingsItemContainer.module.scss'

export const UserSettingsItemContainer = ({ children }) => {
  const BoxElementStyle = ClassHelper(Style, {})

  return <div className={BoxElementStyle}>{children}</div>
}
